import React from 'react';
import { Form, Button, Icon, Message, Divider } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

//utils
import queries from '../../../utils/queries'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

const DetalleNivel1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento._id}>{props.elemento.descrPerfil}</option>
  )
};

const Lista = ({styles, handleListaP, listP}) => {
  const Nivel1Detalle = listP.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="perfil" id="miListaP" onChange={handleListaP}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

//Oficinas
const DetalleNivelOf = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, handleListaOf, listOf}) => {
  const Nivel1Detalle = listOf.map((elemento, _id) => <DetalleNivelOf styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={handleListaOf}>
        {/* <option style={styles.input} value="">Todas...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN Oficinas

//Terceros
const DetalleNivelT = props => {
  return (
    <option style={props.styles.input} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaT = ({styles, handleListaT, listT}) => {
  const Nivel1Detalle = listT.map((elemento, _id) => <DetalleNivelT styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miListaT" onChange={handleListaT}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN terceros

//Tipo de recursos
const DetalleNivelTR = props => {
  return (
    <option style={props.styles.input} value={props.elemento.descrTipoRec}>{props.elemento.descrTipoRec}</option>
  )
};

const ListaTR = ({styles, handleListaTR, listTR}) => {
  const Nivel1Detalle = listTR.map((elemento, _id) => <DetalleNivelTR styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrTipoRec" id="miListaTR" onChange={handleListaTR}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN Tipo de recursos

const AddUsu2 = ({styles, handleSubmit, codigoCiudadUA, codigoDptoUA, handleListaOf, handleListaP,
                  handleLista, handleLista1, handleListaT, handleListaTR,
                  handleChange, args, errors, list, list1, list2, listTR, data: {allPerfiles=[], props}}) => {
  //   console.log(list1)  
  // console.log(args)
  const actInact = true

  if(codigoCiudadUA!=="Todas..."){
    let dpto = document.getElementById("miLista");
    if(dpto){
      dpto.options.selectedIndex = 0
    }
  }

  let argsSelDpto = {...args}
  argsSelDpto._id = args._idDpto
  let colecc = selciudad(list1, argsSelDpto, codigoCiudadUA)
  let listCiu = colecc.listCiu

// console.log(listCiu)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Usuario nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Correo electrónico</label>
                  <input style={styles.input} type='email' autoComplete="off" name="email" id="email" onChange={handleChange} placeholder='Correo electrónico' icon={!errors.length?null: _find(errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Nombre del usuario</label>
                  <input style={styles.input} autoComplete="off" name="nombreUsuario" id="nombreUsuario" onChange={handleChange} placeholder='Nombre del usuario' icon={!errors.length?null: _find(errors, {path:'nombreUsuario'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Clave de acceso</label>
                  <input style={styles.input} autoComplete="new-password" name="claveDeAcceso" id="claveDeAcceso" onChange={handleChange} type='password' placeholder='Clave de acceso' icon={!errors.length?null: _find(errors, {path:'Clave de acceso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Perfil</label>
                  <Lista listP={allPerfiles} styles={styles} handleListaP={handleListaP} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Oficina</label>
                  <ListaOf listOf={list2} styles={styles} handleListaOf={handleListaOf} />
                </Form.Field>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Solo clientes del Departamento</label>
                        <ListaDe list={list1} styles={styles} handleLista={handleLista}
                          codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Solo clientes de la Ciudad</label>
                        <ListaCi list={listCiu} styles={styles} handleLista1={handleLista1} args={args}
                          codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>
                      </div>
                    </div>
                  </div>
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>En Recibir pago - Terceros, solo recibir del tercero</label>
                  <ListaT listT={list} styles={styles} handleListaT={handleListaT} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Solo OS del tipo de recurso</label>
                  <ListaTR listTR={listTR} styles={styles} handleListaTR={handleListaTR} />
                </Form.Field>

                <Form.Field>
                  <label style={styles.label}>INACTIVO / ACTIVO</label>
                  <Form.Checkbox defaultChecked={actInact} name="estadoUsuario" id="estadoUsuario" className='ui fitted toggle checkbox' onChange={handleChange}/>
                </Form.Field>

                <Form.Field>
                  <p style={{color: '#FFE000', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="userApp" id="userApp" onChange={handleChange}/>
                    &nbsp;&nbsp;Usuario App
                  </p>
                </Form.Field>

                <Divider inverted />

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default graphql(queries.query.allPerfiles)(AddUsu2)
